
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form10";
const form10State = namespace("Form10");

import Form10ProcessHeader from "@/components/process/Form10/components/Form10ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { packageInfoType } from '@/types/Information';
import { form10StatusInfoType } from '@/types/Information/Form10';

@Component({
    components:{
        Form10ProcessHeader,
        Spinner
    }
})
export default class SubmitForm10 extends Vue {

    @form10State.State
    public currentOrderSingleJusticeId: string;

    stepsCompleted = {} as form10StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="Form10"
        const url = '/form10/form-print/'+this.currentOrderSingleJusticeId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }

    // public submit() {

    //     this.submitting = true;
    //     this.errorMsg =""

    //     const url = "/form10/efiling/"+this.currentOrderSingleJusticeId+"/submit/";

    //     const header = {
    //         responseType: "json",
    //         headers: {
    //             "Content-Type": "application/json",
    //         }
    //     }

    //     this.$http.post(url, header)
    //     .then(res => {                            
    //         this.submitting = false;
    //         if(res.data?.message=="success" && res.data?.redirectUrl){
    //             const eFilingUrl = res.data?.redirectUrl
    //             location.replace(eFilingUrl);
    //         }
    //     }, err => {
    //         console.log(err.response?.data?.message);
    //         const generalError = " Error in submission. Please refresh the page and try again."
    //         if(err.response?.data?.message)
    //             this.errorMsg = err.response.data.message
    //         else if(err.response?.data?.detail)
    //             this.errorMsg = err.response.data.detail+generalError
    //         else
    //             this.errorMsg = generalError
    //         this.submitting = false;
    //     });        
    // }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
